export default __webpack_public_path__ + "static/media/game.99ba5afa.mp4";